import { InjectionToken } from '@angular/core';
/* eslint-disable @typescript-eslint/no-explicit-any */
export const OVERLAY_DATA = new InjectionToken<any>('OVERLAY_DATA');

// Injection token for the configuration that is passed in to the overlay.
export const OVERLAY_CONFIG = new InjectionToken<any>('OVERLAY_CONFIG');
